// FormulaRegistry class manages a registry of the default formula setting

export class FormulaRegistry {
   static formulas = {};
   static defaultFormula = 'standard';

   static getDefaultFormula() {
     return FormulaRegistry.defaultFormula;
   }

   // Registers a new formula with given ID and optional default flag
   // Throws error if formula ID already exists
   static register(id, formula, isDefault = false) {
     if (FormulaRegistry.formulas[id]) {
       throw new Error(`Formula with id ${id} already exists`);
     }

     FormulaRegistry.formulas[id] = formula;
     if (isDefault) {
       FormulaRegistry.defaultFormula = id;
     }
   }

   // Retrieves a formula by ID
   // Throws error if formula not found
   static get(id) {
      const formulaId = id || FormulaRegistry.defaultFormula;
      const formula = FormulaRegistry.formulas[formulaId];
      if (!formula) {
        throw new Error(`Formula ${formulaId} not found`);
      }
      return formula;
    }
}
